import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h5 q-mb-md" }, "Delete industry", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Are you sure you want to remove ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" industry?")
const _hoisted_4 = { class: "bg-warning text-white rounded q-pa-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Warning", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" This industry is assigned to ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "bg-white text-dark",
        style: {"width":"420px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("span", null, [
                _hoisted_2,
                _createElementVNode("strong", null, _toDisplayString(_ctx.industryName), 1),
                _hoisted_3
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, {
            hidden: _ctx.associatedOrganizations.count == 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("strong", null, _toDisplayString(_ctx.associatedOrganizations.count), 1),
                _createTextVNode(" organization" + _toDisplayString(_ctx.associatedOrganizations.count>1 ? 's' : '') + ". ", 1)
              ])
            ]),
            _: 1
          }, 8, ["hidden"]),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                label: "Cancel",
                color: "primary",
                onClick: _ctx.onCancelClick
              }, null, 8, ["onClick"]),
              _withDirectives(_createVNode(_component_q_btn, {
                label: "Yes, delete!",
                onClick: _ctx.onDialogOk,
                class: "text-orange-7",
                disable: !_ctx.readyToProceed()
              }, null, 8, ["onClick", "disable"]), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}